import ImagingViewer from "../ImagingViewer";

/** The `measures/imaging-ct` route: ImagingViewer locked to modality "CT". */
export default function ImagingViewerCT() {
  return <ImagingViewer modality="CT" />;
}
